/* SleepFit face page, bundle offer (Single / Duo / Trio). Loaded only when the section's offer is "bundle".
   The hero ORDER NOW adds the chosen pack with _sf_offer + _sf_id line properties; the "SleepFit bundle pricing" automatic
   discount (~/shopify-apps/needoh-box-pricing, extensions/sleepfit-pricing) prices those lines. No code, no gift.
   Runs in the capture phase, before sleepfit-lp.js's own buy handler. Every other button still scrolls to the picker. */
(function () {
  var root = document.querySelector('[data-sf][data-offer="bundle"]');
  var pick = document.querySelector('[data-pick]');
  if (!root || !pick) return;
  var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var dest = root.dataset.checkout === 'cart' ? '/cart' : '/checkout';

  var items = function () {
    var card = pick.querySelector('.sf-pick__card.is-active'), by = {};
    var bid = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var sels = card.querySelectorAll('select');
    if (!sels.length) by[root.dataset.variant] = +card.dataset.qty;
    sels.forEach(function (s) { by[s.value] = (by[s.value] || 0) + 1; });
    return Object.keys(by).map(function (id) { return { id: +id, quantity: by[id], properties: { _sf_offer: '1', _sf_id: bid } }; });
  };

  var buy = function (btn) {
    btn.classList.add('is-loading');
    var ours = {};
    pick.querySelectorAll('.sf-pick__select option').forEach(function (o) { ours[o.value] = 1; });
    ours[root.dataset.variant] = 1;
    fetch(base + 'cart.js', { headers: json }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var reset = {};
        cart.items.forEach(function (it) { if (ours[it.variant_id]) reset[it.key] = 0; });
        return Object.keys(reset).length ? fetch(base + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: reset }) }) : null;
      })
      .then(function () { return fetch(base + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items() }) }); })
      .then(function (r) {
        if (!r.ok) throw r;
        return fetch(base + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ attributes: { 'Free gifts': '' } }) });
      })
      .then(function () { window.location.href = dest; })
      .catch(function () {
        btn.classList.remove('is-loading');
        var e = btn.parentNode.querySelector('.sf-buyerr') || document.createElement('p');
        e.className = 'sf-buyerr'; e.textContent = 'Sorry, that size is unavailable right now. Please choose another.';
        btn.insertAdjacentElement('afterend', e);
      });
  };

  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('a.sf-btn[data-buy]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation(); buy(btn);
  }, true);
})();

/* Club option (page with a club_plan set): ticking "Join the Curiosity Planet Club" shows club prices and puts every pillow line on the
   Kaching selling plan; Buy 2 Get 1 keeps the BOGO code + gifts, as on the normal page. Unticked = sleepfit-lp.js handles the click as usual. */
(function () {
  var root = document.querySelector('[data-sf][data-club-plan]:not([data-club-plan=""])');
  var pick = document.querySelector('[data-pick]');
  var box = pick && pick.querySelector('[data-club]');
  if (!root || !box) return;
  var plan = +root.dataset.clubPlan;
  var sync = function () { root.classList.toggle('is-club', box.checked); };
  box.addEventListener('change', sync); window.addEventListener('pageshow', sync); sync();
  var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var dest = root.dataset.checkout === 'cart' ? '/cart' : '/checkout';
  var items = function () {
    // Buy 2 Get 1: the free (last) pillow goes in as a one-time line, so BOGO (one-time purchases only) makes it free
    // and the monthly renewal is the 2 paid club pillows, not 3.
    var card = pick.querySelector('.sf-pick__card.is-active'), n = +card.dataset.qty, by = {}, free = null;
    var sels = [].slice.call(card.querySelectorAll('select'));
    if (!sels.length) by[root.dataset.variant] = n;
    if (n > 1 && sels.length) free = sels.pop().value;
    // One cart line per club pillow (a hidden _pillow number keeps same-size pillows apart): with 2+ recurring lines Shopify's
    // checkout shows "This order has a recurring charge for multiple items" instead of a recurring subtotal amount.
    var out = sels.map(function (s, i) { return { id: +s.value, quantity: 1, selling_plan: plan, properties: { _pillow: String(i + 1) } }; });
    Object.keys(by).forEach(function (id) { out.push({ id: +id, quantity: by[id], selling_plan: plan }); });
    if (free) out.push({ id: +free, quantity: 1 });
    if (n > 1 && root.dataset.giftVariant) out.push({ id: +root.dataset.giftVariant, quantity: 1 });
    return out;
  };
  var buy = function (btn) {
    btn.classList.add('is-loading');
    var n = +pick.querySelector('.sf-pick__card.is-active').dataset.qty, ours = {};
    pick.querySelectorAll('.sf-pick__select option').forEach(function (o) { ours[o.value] = 1; });
    ours[root.dataset.variant] = 1; if (root.dataset.giftVariant) ours[root.dataset.giftVariant] = 1;
    fetch(base + 'cart.js', { headers: json }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var reset = {}; cart.items.forEach(function (it) { if (ours[it.variant_id]) reset[it.key] = 0; });
        return Object.keys(reset).length ? fetch(base + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: reset }) }) : null;
      })
      .then(function () { return fetch(base + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items() }) }); })
      .then(function (r) {
        if (!r.ok) throw r;
        var body = n > 1 && root.dataset.discount ? { discount: root.dataset.discount, attributes: { 'Free gifts': root.dataset.gifts || '' } } : { attributes: { 'Free gifts': '' } };
        return fetch(base + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify(body) });
      })
      .then(function () { window.location.href = dest; })
      .catch(function () {
        btn.classList.remove('is-loading');
        var e = btn.parentNode.querySelector('.sf-buyerr') || document.createElement('p');
        e.className = 'sf-buyerr'; e.textContent = 'Sorry, that size is unavailable right now. Please choose another.';
        btn.insertAdjacentElement('afterend', e);
      });
  };
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('a.sf-btn[data-buy]');
    if (!btn || !box.checked) return;
    e.preventDefault(); e.stopPropagation(); buy(btn);
  }, true);
})();
